import React, { useContext, useState } from "react";
import _ from "lodash";

import { Typography, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import EnvironmentDisplay from "./Logo/EnvironmentDisplay_V";
import VersionDisplay from "./Logo/VersionDisplay_V";
import { kioskstyles } from "./../../../kioskstyles";

import SocketIOContext from "../../../contexts/Kiosk/SocketProvider/SocketIOContext";

let env = require("./../../../env");

// props has activeStep
export default function Logo(props) {
  //const theme = useTheme();
  const { getKioskTheme } = useContext(SocketIOContext);

  const [loading, setLoading] = useState(true);

  const kioskTheme = getKioskTheme();

  console.log("kioskTheme", kioskTheme);

  let environment_text = env.REACT_APP_ENV;
  if (env.REACT_APP_ENV == "PROD") {
    environment_text = "";
  }

  return (
    <div
      style={
        {
          //maxWidth: "700px"
        }
      }
    >
      {/* <Typography
        variant="body2"
        style={{
          color: "yellow",
          //marginTop: theme.spacing(5),
          // paddingRight: "clamp(0px, 27vw, 416px)",
          //paddingRight: "clamp(0px, 27vw, 446px)",
          fontSize: "clamp(12px, 3vw, 36px)",
          //height: "10px",
          fontWeight: "bold",
          //position: "relative",
          top: "0px",
          left: "0px"
        }}
      >
        {environment_text}
      </Typography> */}
      <EnvironmentDisplay />

      {kioskTheme.headerLogoPath && loading ? (
        <div>
          <CircularProgress />
        </div>
      ) : (
        <></>
      )}
      <img
        //src="/img/consignaction-logo-cropped.png"
        src={
          // kioskTheme.headerLogoPath
          //   ? env.REACT_APP_API_ENDPOINT + "/kiosk/getHeaderLogo"
          //   : "/img/consignaction-logo-cropped.png"
          env.REACT_APP_API_ENDPOINT +
          "/kiosk/getImage/HeaderLogo1" +
          "?t=" +
          kioskTheme.lastUpdatedImgETag
        }
        onLoad={() => setLoading(false)}
        style={{
          width: "80%",
          // width: "1354px",
          // height: "182px",
          position: "relative",
          top: "0px",
          left: "0px",
          display: loading ? "hidden" : "block"
        }}
        alt="Consignaction Logo"
      ></img>

      <VersionDisplay />
    </div>
  );
}
